module.exports = __webpack_public_path__ + "137247300fbf6e10ffd1485cb017057c.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/SuisseIntlMono-Regular.woff2
// module id = 1043
// module chunks = 0